<template>
  <div v-if="courseShow" class="full-reduction-pop">
    <div class="contentPop">
      <img @click="onClose" class="closed" src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/closed.png" alt="" />
      <img class="success" src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/success.png" alt="" />
      <h3>激活成功！</h3>
      <div class="checkbtn" v-if="subCatalogId" @click="myCourse">
        {{ productType * 1 === 3 ? '查看图书' : '查看课程' }}
      </div>
    </div>
  </div>
</template>

<script>

import { judgmentPlatform } from '@/utils/tools';
import wx from 'weixin-js-sdk';

export default {
  props: {
    courseShow: Boolean,
    subCatalogId: String,
    productType: String,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    // 跳转导学页
    myCourse() {
      console.log('是否是电子书', this.productType * 1 === 3 ? '是' : '否');
      if (this.$root.$data.isApp) {
        if (this.productType * 1 === 3) {
          if ((judgmentPlatform() === 'android' && !this.$root.checkVersion('5.8.4')) || (judgmentPlatform() === 'ios' && !this.$root.checkVersion('5.8.6'))) {
            this.$toast('请更新最新版本后开始学习');
          } else {
            this.$sendToApp('goEBookTutorialPage', { userProductId: this.subCatalogId * 1 }, false);
          }
          return;
        }
        this.$sendToApp('goDirectoryPage', { courseId: this.subCatalogId * 1 }, false);
      } else if (this.$root.$data.miniprogram) {
        if (this.productType * 1 === 3) {
          wx.miniProgram.navigateTo({ url: `/myCourse/eBookLearnPage/index?openCourseId=${this.subCatalogId}` });
        } else {
          wx.miniProgram.navigateTo({ url: `/myCourse/learningGuide/index?catalogId=${this.subCatalogId}` });
        }
      } else {
        if (this.productType * 1 === 3) {
          this.$toast('请前往启航教育app查看电子书');
          return;
        }
        this.$router.push({
          path: '/learningGuide',
          query: { catalogId: this.subCatalogId * 1 },
        });
      }
    },
    onClose() {
      this.$emit('courseChangeShow');
    },
  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.3);

  .contentPop {
    position: relative;
    top: 50%;
    width: 654px;
    height: 430px;
    margin: 0 auto;
    padding-top: 80px;
    background: #fff;
    border-radius: 16px;
    transform: translateY(-50%);

    .closed {
      position: absolute;
      top: 30px;
      right: 30px;
    }

    .success {
      display: block;
      width: 96px;
      height: 96px;
      margin: 0 auto;
    }

    h3 {
      margin: 44px 0;
      color: #000;
      font-weight: 400;
      font-size: 28px;
      text-align: center;
    }

    .checkbtn {
      width: 324px;
      height: 76px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 32px;
      line-height: 76px;
      text-align: center;
      background: #ff7f41;
      border-radius: 50px;
    }
  }
}
</style>
